<template>
  <div>
    <div
      v-if="isScheduledReportsLoading"
      class="d-flex justify-content-center align-content-center mt-4"
    >
      <CSpinner color="primary" />
    </div>
    <div v-else class="d-flex flex-column gap-4 mt-4">
      <!-- SERVER ERROR -->
      <ErrorHandler
        v-if="serverError != null"
        :error="serverError"
        @done="serverError = null"
      />
      <!-- SERVER ERROR -->

      <!-- SCHEDULED REPORTS TABLE AND FILTER -->
      <ScheduledReportsTable />
      <!-- SCHEDULED REPORTS TABLE AND FILTER -->
    </div>
  </div>
</template>
<script>
import ScheduledReportsTable from "@/v3components/AdvanceReporting/ScheduledReportsTable.vue"
import ErrorHandler from "@/v3components/VisitorErrorHandler.vue"
import { onMounted, ref } from "vue"
import { useStore } from "vuex"

export default {
  name: "ScheduledReports",
  components: { ScheduledReportsTable, ErrorHandler },
  setup() {
    const store = useStore()
    const isScheduledReportsLoading = ref(true)
    const serverError = ref(null)

    onMounted(async () => {
      try {
        isScheduledReportsLoading.value = true
        await store.dispatch("advanceReportingStore/fetchChartSettings")
        await store.dispatch("advanceReportingStore/fetchScheduledReports")
      } catch (error) {
        serverError.value = error
      } finally {
        isScheduledReportsLoading.value = false
      }
    })

    return { isScheduledReportsLoading, serverError }
  }
}
</script>
